import opentelemetry from '@opentelemetry/api'
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http'
import {
  MeterProvider,
  PeriodicExportingMetricReader,
  AggregationTemporality
} from '@opentelemetry/sdk-metrics'
import { resourceFromAttributes } from '@opentelemetry/resources'
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION
} from '@opentelemetry/semantic-conventions'
import { environment } from '../../environments/environment'
import {
  METER_PROVIDER_SERVICE_NAME,
  METER_PROVIDER_SERVICE_VERSION
} from '../constants/metric-names'

const metricExporter = new OTLPMetricExporter({
  url: environment.otelCollectorUrl,
  headers: {
    Authorization: environment.otelAuthorization
  },
  temporalityPreference: AggregationTemporality.DELTA
})

export const periodicExportingMetricReader = new PeriodicExportingMetricReader({
  exporter: metricExporter,
  // exporter: new ConsoleMetricExporter(),
  exportIntervalMillis: 5000
})

const meterProvider = new MeterProvider({
  resource: resourceFromAttributes({
    [ATTR_SERVICE_NAME]: METER_PROVIDER_SERVICE_NAME,
    [ATTR_SERVICE_VERSION]: METER_PROVIDER_SERVICE_VERSION
  }),
  readers: [periodicExportingMetricReader]
})

opentelemetry.metrics.setGlobalMeterProvider(meterProvider)
